import { PHASE_HEX } from '../../utils/phaseColors';
import type { StatusPreview } from './statusPreview';

/** Compact status card: phase chip on top, step name below. Used by the
 *  from→to transition preview in ExitHoldConfirmModal, ActionModal and hold task bodies. */
export function StatusChip({ preview }: { preview: StatusPreview }) {
    const phaseColor = PHASE_HEX[preview.phase] ?? 'rgb(107,114,128)';
    return (
        <div className="bg-white rounded-md border border-gray-200 px-2.5 py-2 min-w-0">
            <div
                className="text-[10px] font-bold uppercase tracking-wider"
                style={{ color: phaseColor }}
            >
                {preview.phase}
            </div>
            <div className="text-xs font-medium text-gray-800 leading-snug truncate">
                {preview.name}
            </div>
        </div>
    );
}
